/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_No_Data_ErrorInputs */



/**
* | output |
* | --- |
* | "No data found in response" |
*
* @param {Voice_Manager_No_Data_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_no_data_error = /** @type {((inputs?: Voice_Manager_No_Data_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_No_Data_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune donnee trouvee dans la reponse")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine Daten gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun dato trovato nella risposta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Данные в ответе не найдены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron datos en la respuesta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到响应数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("応答にデータが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तर में कोई डेटा नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum dado encontrado na resposta.")
	return /** @type {LocalizedString} */ ("No data found in response")
});